import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useForm from 'components/FormUse';
import Loading from 'components/Loading';
import './style.scss';

const FormLostPass = ({ processData = null }) => {

    const [isLoading, setIsLoading] = useState(false);

    const {
        handleSubmit,
        handleChange,
        data,
        errors,
    } = useForm({
        validations: {
            email: {
                pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Ingrese un email válido"
                }
            }
        },
        onSubmit: (data) => {
            setIsLoading(true);
            setTimeout(() => {
                processData && processData(2, data);
            }, 1500);
        },
        initialValues: {
            email: ''
        }
    });

    return (
        <>
        <form onSubmit={handleSubmit}>
            <p className="text-center">Ingresa tu correo para<br/>restablecer tu contraseña</p>
            <div className="form-group">
                <input value={data.email || ''} onChange={handleChange('email')} required maxLength="150" type="email" className="form-control" name="textBoxEmail" id="textBoxEmail" placeholder="Correo electrónico" />
                {errors.email && <p className="error-form">{errors.email}</p>}
            </div>
            <p className="buttons text-center">
                <button type="submit" className="btn btn-primary btn-main no-hover hover-metro">
                    {isLoading ? <Loading type="metro--hover" /> : 'Enviar'}
                </button>
            </p>
        </form>
        </>
    );
}

FormLostPass.propTypes = {
    processData: PropTypes.func
};
export default FormLostPass;